
// import React, { useEffect, useRef } from 'react';
// import './Home.css';
// import { useLanguage } from '../context/LanguageContext';
// import Icon from '../components/Icon';
// import HoliColorEffect from '../components/HoliColorEffect';
// import { Link } from "react-router-dom";
// import yatra from '../Icon/Yatra.png';
// import shravan from '../Icon/shravan.png';
// import poornima from '../Icon/poornima.png';

// import parking from '../Icon/parking.png';
// import restroom from '../Icon/restroom.png';
// import water from '../Icon/water.png';
// import food from '../Icon/food.png';

// import accessibility from '../Icon/accessibility.png';
// import bag from '../Icon/bag.png';






// const Home = ({ setCurrentPage }) => {
//   const { t } = useLanguage();
//   const heroRef = useRef(null);
//   const donateBtnRef = useRef(null);

// const handleYadnyaClick = () => {
//   setCurrentPage('YadnyaBooking');
// };

// const handleMahaprasadClick = () =>{
//   setCurrentPage('MahaprasadBooking');
// }

//   const scrollToSection = (id) => {
//     const element = document.getElementById(id);
//     if (element) {
//       const yOffset = -80;
//       const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
//       window.scrollTo({ top: y, behavior: 'smooth' });
//     }
//   };

//   /* ── Scroll Reveal Observer ── */
// useEffect(() => {
//   const btn = donateBtnRef.current;
//   if (!btn) return;

//   // ✅ MOBILE DETECT
//   const isMobile = window.innerWidth <= 768;
//   if (isMobile) return; // 🔥 mobile वर drag बंद

//   let isDragging = false;
//   let startX, startY;
//   let initialLeft, initialTop;

//   const getPosition = (e) => {
//     return { x: e.clientX, y: e.clientY };
//   };

//   const startDrag = (e) => {
//     const pos = getPosition(e);
//     startX = pos.x;
//     startY = pos.y;

//     const rect = btn.getBoundingClientRect();
//     initialLeft = rect.left;
//     initialTop = rect.top;

//     isDragging = true;
//     btn.classList.add('dragging');

//     btn.style.willChange = 'left, top';
//   };

//   const onDrag = (e) => {
//     if (!isDragging) return;

//     const pos = getPosition(e);
//     const deltaX = pos.x - startX;
//     const deltaY = pos.y - startY;

//     let newLeft = initialLeft + deltaX;
//     let newTop = initialTop + deltaY;

//     const maxLeft = window.innerWidth - btn.offsetWidth - 16;
//     const maxTop = window.innerHeight - btn.offsetHeight - 80;

//     newLeft = Math.max(16, Math.min(newLeft, maxLeft));
//     newTop = Math.max(16, Math.min(newTop, maxTop));

//     btn.style.left = `${newLeft}px`;
//     btn.style.top = `${newTop}px`;
//     btn.style.right = 'auto';
//     btn.style.bottom = 'auto';
//   };

//   const endDrag = () => {
//     if (!isDragging) return;
//     isDragging = false;
//     btn.classList.remove('dragging');
//     btn.style.willChange = 'auto';
//   };

//   btn.addEventListener('mousedown', startDrag);
//   window.addEventListener('mousemove', onDrag);
//   window.addEventListener('mouseup', endDrag);

//   return () => {
//     btn.removeEventListener('mousedown', startDrag);
//     window.removeEventListener('mousemove', onDrag);
//     window.removeEventListener('mouseup', endDrag);
//   };
// }, []);


//   /* ── Draggable Floating Donation Button ── */
// useEffect(() => {
//   const btn = donateBtnRef.current;
//   if (!btn) return;

//   const isMobile = window.innerWidth <= 768;

//   let isDragging = false;
//   let startX, startY;
//   let initialLeft, initialTop;

//   const getPosition = (e) => {
//     if (e.touches && e.touches.length > 0) {
//       return { x: e.touches[0].clientX, y: e.touches[0].clientY };
//     }
//     return { x: e.clientX, y: e.clientY };
//   };

//   // ✅ CLICK HANDLER (ALL DEVICES)
//   const handleClick = (e) => {
//     if (isDragging) {
//       e.preventDefault();
//       return;
//     }
//     setCurrentPage('donation');
//   };

//   btn.addEventListener('click', handleClick);

//   // ✅ MOBILE → ONLY CLICK (NO DRAG)
//   if (isMobile) {
//     return () => {
//       btn.removeEventListener('click', handleClick);
//     };
//   }

//   // ✅ DESKTOP DRAG ONLY
//   const startDrag = (e) => {
//     const pos = getPosition(e);
//     startX = pos.x;
//     startY = pos.y;

//     const rect = btn.getBoundingClientRect();
//     initialLeft = rect.left;
//     initialTop = rect.top;

//     isDragging = true;
//     btn.classList.add('dragging');
//     btn.style.willChange = 'left, top';
//   };

//   const onDrag = (e) => {
//     if (!isDragging) return;

//     const pos = getPosition(e);
//     const deltaX = pos.x - startX;
//     const deltaY = pos.y - startY;

//     let newLeft = initialLeft + deltaX;
//     let newTop = initialTop + deltaY;

//     const maxLeft = window.innerWidth - btn.offsetWidth - 16;
//     const maxTop = window.innerHeight - btn.offsetHeight - 80;

//     newLeft = Math.max(16, Math.min(newLeft, maxLeft));
//     newTop = Math.max(16, Math.min(newTop, maxTop));

//     btn.style.left = `${newLeft}px`;
//     btn.style.top = `${newTop}px`;
//     btn.style.right = 'auto';
//     btn.style.bottom = 'auto';
//   };

//   const endDrag = () => {
//     if (!isDragging) return;
//     isDragging = false;
//     btn.classList.remove('dragging');
//     btn.style.willChange = 'auto';
//   };

//   btn.addEventListener('mousedown', startDrag);
//   window.addEventListener('mousemove', onDrag);
//   window.addEventListener('mouseup', endDrag);

//   return () => {
//     btn.removeEventListener('click', handleClick);
//     btn.removeEventListener('mousedown', startDrag);
//     window.removeEventListener('mousemove', onDrag);
//     window.removeEventListener('mouseup', endDrag);
//   };
// }, [setCurrentPage]);







// // Scroll Reveal – add .visible class when elements enter viewport
// useEffect(() => {
//   const observerOptions = {
//     root: null,           // viewport
//     rootMargin: "0px",    // no extra margin
//     threshold: 0.15       // trigger when 15% of element is visible
//   };

//   const observer = new IntersectionObserver((entries) => {
//     entries.forEach((entry) => {
//       if (entry.isIntersecting) {
//         entry.target.classList.add("visible");
//         // Optional: stop observing after animation (better performance)
//         // observer.unobserve(entry.target);
//       }
//     });
//   }, observerOptions);

//   // Observe all animated cards / sections
//   document.querySelectorAll(
//     ".info-card, .fact-card, .event-card, .facility-card, .reach-card, .ritual-card, .place-card, .testimonial-card"
//   ).forEach((el) => {
//     observer.observe(el);
//   });

//   // Cleanup
//   return () => observer.disconnect();
// }, []);


//   // const status = getDarshanStatus();

//   return (
//     <div className="home-page">
//       {/* ══ HERO ══ */}
//       <section className="hero-section">
//         <picture className="hero-bg-container" ref={heroRef}>
//           <source
//             media="(max-width: 768px)"
//             srcSet="/Assets/home/devmobile4.png"
//           />
//           <img
//             src="/Assets/home/dev2.jpg"
//             alt={t('templeTitle')}
//             className="hero-bg-img"
//             fetchPriority="high"
//             loading="eager"
//           />
//           <HoliColorEffect containerRef={heroRef} />
//         </picture>
//         <div className="hero-vignette-overlay" />
//         <div className="hero-wrapper">
//           <div className="hero-content-center" />
//         </div>
//       </section>

//       {/* ══ RUNNING BANNER ══ */}
//       <section className="running-banner">
//         <div className="banner-content">
//           <div className="marquee">
//             <span className="marquee-text">
//               <span className="star">★</span>
//               {t('pageContent.welcomeTitle')} : {t('home.marqueeMessage')}
//               <span className="star">★</span>
//             </span>
//             <span className="marquee-text">
//               <span className="star">★</span>
//               {t('pageContent.welcomeTitle')} : {t('home.marqueeMessage')}
//               <span className="star">★</span>
//             </span>
//           </div>
//         </div>
//       </section>

//       {/* ══ WELCOME ══ */}
//       <section className="welcome-section">
//         <div className="container">
//           <div className="welcome-card">
//             <div className="welcome-badge">{t('pageContent.welcomeTitle')}</div>
//             <h2 className="welcome-title">{t('pageContent.mainTitle')}</h2>
//             <div className="welcome-divider"></div>
//             <p className="welcome-text">{t('pageContent.welcomeText')}</p>
//           </div>
//         </div>
//       </section>

//       {/* ══ TEMPLE SHOWCASE ══ */}
//       <section className="temple-showcase" id="showcase">
//         <div className="container">
//           <h2 className="section-title">{t('home.showcase.title')}</h2>
//           <div className="divider"></div>
//           <div className="showcase-grid">
//             <div className="showcase-image">
//               <img
//                 src="Assets/home/temple-architecture.jpg"
//                 alt={t('home.showcase.overlayText')}
//                 className="temple-image"
//               />
//               <div className="image-overlay">
//                 <p className="overlay-text">{t('home.showcase.overlayText')}</p>
//               </div>
//             </div>
//             <div className="showcase-info">
//               <div className="info-card">
//                 <div className="info-card-header">
//                   <div className="info-icon"><Icon name="temple" /></div>
//                   <h3>{t('home.showcase.magnificenttitle')}</h3>
//                 </div>
//                 <p>{t('home.showcase.magnificentText')}</p>
//               </div>
//               <div className="info-card">
//                 <div className="info-card-header">
//                   <div className="info-icon"><Icon name="lamp" /></div>
//                   <h3>{t('home.showcase.dailyPoojaTitle')}</h3>
//                 </div>
//                 <p>{t('home.showcase.dailyPoojaText')}</p>
//               </div>
//               <div className="info-card">
//                 <div className="info-card-header">
//                   <div className="info-icon"><Icon name="prayer" /></div>
//                   <h3>{t('home.showcase.spiritualityTitle')}</h3>
//                 </div>
//                 <p>{t('home.showcase.spiritualityText')}</p>
//               </div>
//               <div className="info-card">
//                 <div className="info-card-header">
//                   <div className="info-icon"><Icon name="festival" /></div>
//                   <h3>{t('home.showcase.festivalTraditionTitle')}</h3>
//                 </div>
//                 <p>{t('home.showcase.festivalTraditionText')}</p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* ══ FACTS ══ */}
//       <section className="facts-section" id="facts">
//         <div className="container">
//           <h2 className="section-title">{t('home.facts.title')}</h2>
//           <div className="divider"></div>
//           <div className="facts-grid">
//             <div className="fact-card">
//               <div className="fact-icon"><Icon name="clock" /></div>
//               <h3>{t('home.facts.darshanTitle')}</h3>
//               <p>{t('home.facts.darshanText')}</p>
//             </div>
//             <div className="fact-card">
//               <div className="fact-icon"><Icon name="location" /></div>
//               <h3>{t('home.facts.locationTitle')}</h3>
//               <p>{t('home.facts.locationText')}</p>
//             </div>
//             <div className="fact-card" onClick={() => scrollToSection('reach')}>
//               <div className="fact-icon"><Icon name="car" /></div>
//               <h3>{t('home.facts.reachTitle')}</h3>
//               <p>{t('home.facts.reachText')}</p>
//             </div>
//             <div className="fact-card">
//               <div className="fact-icon"><Icon name="phone" /></div>
//               <h3>{t('home.facts.contactTitle')}</h3>
//               <p>{t('home.facts.contactText')}</p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* ══ EVENTS ══ */}
//       <section className="events-section" id="events">
//         <div className="container">
//           <h2 className="section-title">{t('home.festivals.title')}</h2>
//           <div className="divider"></div>
//           <div  className="events-grid">
          
//             <div className="event-card">
//                <div className="event-icon">
//     <img
//       src={yatra}                     // your chariot image
//       alt="वार्षिक यात्रा पालखी"
//       className="chariot-icon"
//       onError={(e) => {
//         e.target.src = '/fallback-icon.png'; // optional fallback icon
//         // or e.target.style.display = 'none';
//       }}
//     />
//   </div>
//               <div className="event-date">{t('home.festivals.annualYatraDate')}</div>
//               <h3>{t('home.festivals.annualYatraTitle')}</h3>
//               <p>{t('home.festivals.annualYatraText')}</p>
//             </div>
//             <div className="event-card">

//            <div className="event-icon">
//     <img
//       src={shravan}                     // your chariot image
//       alt="वार्षिक यात्रा पालखी"
//       className="chariot-icon"
//       onError={(e) => {
//         e.target.src = '/fallback-icon.png'; // optional fallback icon
//         // or e.target.style.display = 'none';
//       }}
//     />
//   </div>

//               <div className="event-date">{t('home.festivals.shravanMonth')}</div>
//               <h3>{t('home.festivals.shravanTitle')}</h3>
//               <p>{t('home.festivals.shravanText')}</p>
//             </div>
//             <div className="event-card">

//            <div className="event-icon">
//     <img
//       src={poornima}                     // your chariot image
//       alt="वार्षिक यात्रा पालखी"
//       className="chariot-icon"
//       onError={(e) => {
//         e.target.src = '/fallback-icon.png'; // optional fallback icon
//         // or e.target.style.display = 'none';
//       }}
//     />
//   </div>

//               <div className="event-date">{t('home.festivals.everyMonth')}</div>
//               <h3>{t('home.festivals.poornimaTitle')}</h3>
//               <p>{t('home.festivals.poornimaText')}</p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* ══ FACILITIES ══ */}
//       <section className="facilities-section" id="facilities">
//         <div className="container">
//           <h2 className="section-title">{t('home.facilities.title')}</h2>
//           <div className="divider"></div>
//           <div className="facilities-grid">
//             <div className="facility-card">
//               <div className="facility-icon">
//                  {/* <div className="event-icon"> */}
//     <img
//       src={parking}                     // your chariot image
//       alt="वार्षिक यात्रा पालखी"
//       className=""
//       onError={(e) => {
//         e.target.src = '/fallback-icon.png'; // optional fallback icon
//         // or e.target.style.display = 'none';
//       }}
//     />
//   </div>
//   {/* </div> */}
//               <h3>{t('home.facilities.parkingTitle')}</h3>
//               <p>{t('home.facilities.parkingText')}</p>
//             </div>
//             <div className="facility-card">
//               <div className="facility-icon">
//                 {/* <div className="event-icon"> */}
//     <img
//       src={restroom}                     // your chariot image
//       alt="वार्षिक यात्रा पालखी"
//       className="chariot-icon"
//       onError={(e) => {
//         e.target.src = '/fallback-icon.png'; // optional fallback icon
//         // or e.target.style.display = 'none';
//       }}
//     />
//   </div>
//   {/* </div> */}
//               <h3>{t('home.facilities.restroomTitle')}</h3>
//               <p>{t('home.facilities.restroomText')}</p>
//             </div>
//             <div className="facility-card">
//               <div className="facility-icon">
//                 {/* <div className="event-icon"> */}
//     <img
//       src={water}                     // your chariot image
//       alt="वार्षिक यात्रा पालखी"
//       className="chariot-icon"
//       onError={(e) => {
//         e.target.src = '/fallback-icon.png'; // optional fallback icon
//         // or e.target.style.display = 'none';
//       }}
//     />
//   </div>
//   {/* </div> */}
//               <h3>{t('home.facilities.waterTitle')}</h3>
//               <p>{t('home.facilities.waterText')}</p>
//             </div>
//             <div className="facility-card">
//               <div className="facility-icon">
//                 {/* <div className="event-icon"> */}
//     <img
//       src={food}                     // your chariot image
//       alt="वार्षिक यात्रा पालखी"
//       className="chariot-icon"
//       onError={(e) => {
//         e.target.src = '/fallback-icon.png'; // optional fallback icon
//         // or e.target.style.display = 'none';
//       }}
//     />
//   </div>
//   {/* </div> */}
//               <h3>{t('home.facilities.prasadTitle')}</h3>
//               <p>{t('home.facilities.prasadText')}</p>
//             </div>
//             <div className="facility-card">
//               <div className="facility-icon">
//                 {/* <div className="event-icon"> */}
//     <img
//       src={accessibility}                     // your chariot image
//       alt="वार्षिक यात्रा पालखी"
//       className="chariot-icon"
//       onError={(e) => {
//         e.target.src = '/fallback-icon.png'; // optional fallback icon
//         // or e.target.style.display = 'none';
//       }}
//     />
//   </div>
//   {/* </div> */}
//               <h3>{t('home.facilities.seniorTitle')}</h3>
//               <p>{t('home.facilities.seniorText')}</p>
//             </div>
//             <div className="facility-card">
//               <div className="facility-icon">
//                 {/* <div className="event-icon"> */}
//     <img
//       src={bag}                     // your chariot image
//       alt="वार्षिक यात्रा पालखी"
//       className="chariot-icon"
//       onError={(e) => {
//         e.target.src = '/fallback-icon.png'; // optional fallback icon
//         // or e.target.style.display = 'none';
//       }}
//     />
//   </div>
//   {/* </div> */}
//               <h3>{t('home.facilities.materialTitle')}</h3>
//               <p>{t('home.facilities.materialText')}</p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* ══ REACH ══ */}
//       <section className="reach-section" id="reach">
//         <div className="container">
//           <h2 className="section-title">{t('home.reach.title')}</h2>
//           <div className="divider"></div>
//           <div className="reach-content">
//             <div className="reach-card">
//               <div className="reach-icon"><Icon name="train" /></div>
//               <h3>{t('home.reach.railwayTitle')}</h3>
//               <p>{t('home.reach.railwayText')}</p>
//               <p><strong>{t('home.reach.railwayNote')}</strong></p>
//             </div>
//             <div className="reach-card">
//               <div className="reach-icon"><Icon name="bus" /></div>
//               <h3>{t('home.reach.busTitle')}</h3>
//               <p>{t('home.reach.busText')}</p>
//               <p><strong>{t('home.reach.busNote')}</strong></p>
//             </div>
//             <div className="reach-card">
//               <div className="reach-icon"><Icon name="car" /></div>
//               <h3>{t('home.reach.carTitle')}</h3>
//               <p>{t('home.reach.carText')}</p>
//               <p><strong>{t('home.reach.carNote')}</strong></p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* ══ FLOATING DONATION BUTTON (Draggable) ══ */}
//       {/* <button
//         ref={donateBtnRef}
//         className="floating-donation-btn"
//       >
//         <span className="btn-text">{t('donation.dontionbutton')}</span>
//         <span className="btn-icon">₹</span> 
//       </button>


//  <button
//         ref={donateBtnRef}
//         className=""
//       >
//         <span className="">{t('donation.dontionbutton')}</span>
//         <span className="">₹</span> 
//       </button> */}




// <div className="floating-btn-group">
//   {/* Yadnya */}
//   {/* <button
//     className="floating-yadnya-btn"
//     onClick={() => setCurrentPage('yadnyaBooking')}
//   >
//     <span className="btn-text">Yadnya Booking</span>
//     <span className="btn-icon">🔥</span>
//   </button> */}

// <button
//   className="floating-yadnya-btn"
//   onClick={handleYadnyaClick}
// >
//   <span className="btn-text">{t('yadnya.YadnyaBooking')}</span>
//   {/* <span className="btn-icon">🔥</span> */}
// </button>

// <button
//   className="floating-mahaprasad-btn"
//   onClick={handleMahaprasadClick}
// >
//   <span className="btn-text">{t('mahaprasad.MahaprasadBooking')}</span>
//   {/* <span className="btn-icon">🔥</span> */}
// </button>

//   {/* Donation */}
//   <button
//     ref={donateBtnRef}
//     className="floating-donation-btn"
//   >
//     <span className="btn-text">{t('donation.dontionbutton')}</span>
//     <span className="btn-icon">₹</span>
//   </button>
// </div>


//       {/* <h1>jgdjgjdsgjdgh</h1> */}


//     </div>
//   );
// };

// export default Home;



















import React, { useEffect, useRef, useState } from 'react';
import './Home.css';
import { useLanguage } from '../context/LanguageContext';
import Icon from '../components/Icon';
import HoliColorEffect from '../components/HoliColorEffect';

import yatra from '../Icon/Yatra.png';
import shravan from '../Icon/shravan.png';
import poornima from '../Icon/poornima.png';
import kalbhairav from '../Icon/Festival.png';

import parking from '../Icon/parking.png';
import restroom from '../Icon/restroom.png';
import water from '../Icon/water.png';
import food from '../Icon/food.png';
import accessibility from '../Icon/accessibility.png';
import bag from '../Icon/bag.png';

/* ══════════════════════════════════════════
   TEMPLE HISTORY MODAL (new)
══════════════════════════════════════════ */
const TempleHistoryModal = ({ isOpen, onClose }) => {
  const modalRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      setTimeout(() => {
        if (modalRef.current) modalRef.current.scrollTop = 0;
      }, 50);
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  useEffect(() => {
    const handleKey = (e) => { if (e.key === 'Escape') onClose(); };
    if (isOpen) window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="vastu-modal-backdrop" onClick={handleBackdropClick}>
      <div className="vastu-modal history-modal" role="dialog" aria-modal="true">

        {/* Header */}
        <div className="history-modal-header">
          <div className="history-modal-title-wrap">
            <span className="history-modal-diya">🪔</span>
            <div>
              <p className="history-modal-pretitle">श्री क्षेत्र कोडीत</p>
              <h2 className="history-modal-title">मंदिराचा इतिहास</h2>
            </div>
          </div>
          <button className="vastu-modal-close history-close-btn" onClick={onClose}>✕</button>
        </div>

        {/* Body */}
        <div className="vastu-modal-body history-modal-body" ref={modalRef}>

          <div className="history-ornament">
            <span>✦</span>
            <span className="history-ornament-center">🔱</span>
            <span>✦</span>
          </div>

          {/* Block 1 */}
          <div className="history-section-block">
            <div className="history-section-label">उगम</div>
            <p className="history-para">
              काशी खंडाचे काळभैरव श्रीनाथ म्हस्कोबा महाराज यांचे श्री क्षेत्र कोडीत येथील मंदिर हे
              साधारण <strong>सतराव्या शतकापासून</strong> आहे.
            </p>
            <p className="history-para">
              श्रीनाथ म्हस्कोबा महाराज हे श्री काळभैरव स्वरूप असून दक्षिण भारतात काळभैरवनाथ
              यांच्या दक्षिण अवतराला अनेक वेगवेगळी नावे आहेत व प्रत्येक नावामागे एक आख्यायिका
              जोडलेली आहे.
            </p>
          </div>

          <div className="history-divider-line" />

          {/* Block 2 */}
          <div className="history-section-block">
            <div className="history-section-label">आगमन</div>
            <p className="history-para">
              श्रीनाथ म्हस्कोबा हे <strong>श्री क्षेत्र वीर</strong> येथून श्री क्षेत्र कोडीत येथे
              भक्त श्री तुळाजीबुवा बडदे पाटील यांच्या समवेत आलेले असून ते मूळचे सोनार सिद्ध म्हणजेच
              श्री काळभैरव आहेत.
            </p>
            <p className="history-para">
              श्री भक्त कमळाजी यांच्या भक्ती मार्गातून श्री क्षेत्र सोनारी येथून सोनार सिद्ध
              काळभैरव हे वीरगावी येऊन म्हसनवट्यात प्रकट झाले व त्यामुळे त्यांना
              <strong> श्री म्हस्कोबा </strong> हे नाव मिळाले.
            </p>
          </div>

          <div className="history-highlight-card">
            <span className="history-highlight-icon">🚩</span>
            <p>
              श्री क्षेत्र वीर व श्री क्षेत्र कोडीत येथील दोन्ही मंदिरे गावच्या वेशीवर आहेत.
              वीरची यात्रा ही <strong>दहा दिवसांची</strong> सर्वात मोठी यात्रा भरते — या यात्रेला
              श्री क्षेत्र कोडीत येथून सासनकाठी व पालखी संपूर्ण यात्रा काळात मुक्कामासाठी जाते.
            </p>
          </div>

          <div className="history-divider-line" />

          {/* Block 3 */}
          <div className="history-section-block">
            <div className="history-section-label">दिव्य प्रवास</div>
            <p className="history-para">
              काशी खंडाचे काळभैरव हे मूळचे शिव अवतार असून त्यांनी काशी येथून दक्षिणेकडे
              येण्यासाठी दक्षिण भैरव अवतार घेतला. उज्जैन, सोनारी येथून कोल्हापूरसह पातळ
              लोकात जाऊन <strong>श्री जोगेश्वरी मातेशी विवाह</strong> केला.
            </p>
            <p className="history-para">
              अनेक दृष्ट शक्तींचा नायनाट करून भक्तांना अभय दिले. श्री क्षेत्र सोनारी येथे
              <strong> सुवर्णासुराचा वध </strong> करून सोनार सिद्ध म्हणून सोनारी येथे स्थापन झाले.
            </p>
          </div>

          <div className="history-divider-line" />

          {/* Block 4 */}
          <div className="history-section-block">
            <div className="history-section-label">भक्त परंपरा</div>
            <p className="history-para">
              <strong>तुळाजी बुवा बडदे पाटील</strong> हे मूळचे सातारा जिल्ह्यातील भुईंज गावचे भोसले
              पाटील घराण्यातून असून ते पुरंदरच्या कोंदणात क-हा नदीच्या किनारी वसलेल्या कोडीत या सुंदर गावात वास्तव्यास आले..
            </p>
            <p className="history-para">
              तुळाजीबुवा बडदे पाटलांनी आपल्या अपार भक्तीतून श्रीनाथ म्हस्कोबा महाराजांना प्रसन्न करून
              घेतले. त्यानुसार <strong>मोरपीस असणारी सासनकाठी व छबीना</strong> घेऊन कोडीत
              गाव वीर येथे संपूर्ण यात्रा काळ महाराजांच्या सेवेसाठी रुजू असते.
            </p>
          </div>

          <div className="history-closing-block">
            <div className="history-ornament">
              <span>✦</span>
              <span className="history-ornament-center">🔱</span>
              <span>✦</span>
            </div>
            <p className="history-closing-text">
              "भक्ती, श्रद्धा आणि परंपरेचा हा अखंड प्रवाह<br />
              युगानुयुगे वाहत राहील."
            </p>
          </div>

        </div>

        {/* Footer */}
        <div className="vastu-modal-footer">
          <button className="vastu-close-btn" onClick={onClose}>बंद करा</button>
        </div>
      </div>
    </div>
  );
};

/* ══════════════════════════════════════════
   VASTU MODAL
══════════════════════════════════════════ */
const VastuModal = ({ isOpen, onClose }) => {
  const modalRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      setTimeout(() => { if (modalRef.current) modalRef.current.scrollTop = 0; }, 50);
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  const handleBackdropClick = (e) => { if (e.target === e.currentTarget) onClose(); };

  useEffect(() => {
    const handleKey = (e) => { if (e.key === 'Escape') onClose(); };
    if (isOpen) window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="vastu-modal-backdrop" onClick={handleBackdropClick}>
      <div className="vastu-modal" role="dialog" aria-modal="true">
        <div className="vastu-modal-header">
          <div className="vastu-modal-title-wrap">
            <span className="vastu-modal-icon">🏛️</span>
            <h2 className="vastu-modal-title">भव्य वास्तुशिल्प आणि वैशिष्ट्ये</h2>
          </div>
          <button className="vastu-modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="vastu-modal-body" ref={modalRef}>
          <div className="vastu-modal-divider"><span>✦</span><span>✦</span><span>✦</span></div>
          <p className="vastu-modal-subtitle">परंपरा, कौशल्य आणि सौंदर्याचा अद्वितीय संगम</p>
          <p className="vastu-modal-text">
            कोडीत क्षेत्र येथील श्रीनाथ म्हस्कोबा महाराज मंदिर हे केवळ श्रद्धेचे केंद्र नसून,
            भारतीय प्राचीन वास्तुकलेच्या वैभवशाली परंपरेचे एक जिवंत दालन आहे.
          </p>
          <div className="vastu-highlight-box">
            <h3 className="vastu-highlight-title">🎨 देशभरातील कुशल कारागीर</h3>
            <p className="vastu-modal-text">
              मंदिर उभारणीच्या या भव्य कार्यामध्ये संपूर्ण भारतभरातून तामिळनाडू, आंध्रप्रदेश,
              कर्नाटक, महाराष्ट्र, मध्यप्रदेश, उत्तरप्रदेश, गुजरात, राजस्थान, हरियाणा आणि पंजाब
              या राज्यांतील कुशल कारागिरांनी आपले अमूल्य योगदान दिले.
            </p>
          </div>
          <h3 className="vastu-section-heading">🏯 वास्तुशैलींचा अद्वितीय संगम</h3>
          <div className="vastu-styles-grid">
            {[
              { icon: '🔱', title: 'द्रविड शैली', desc: 'भव्यता आणि उंच गोपुरम रचना' },
              { icon: '🕌', title: 'नागर शैली', desc: 'उंची आणि आकर्षक शिखर रचना' },
              { icon: '🪔', title: 'पंढरपूर शैली', desc: 'साधी पण भक्तिमय बांधणी' },
              { icon: '🌸', title: 'सोमपुरा परंपरा', desc: 'सूक्ष्म कोरीव नक्षी कला' },
              { icon: '🪨', title: 'हेमाडपंथी शैली', desc: 'मजबुती आणि टिकाऊ बांधकाम' },
            ].map((s) => (
              <div className="vastu-style-card" key={s.title}>
                <span className="vastu-style-icon">{s.icon}</span>
                <h4>{s.title}</h4>
                <p>{s.desc}</p>
              </div>
            ))}
          </div>
          <div className="vastu-closing-quote">
            <p>
              "हे मंदिर म्हणजे केवळ दगडांची रचना नाही…<br />
              तर ती आहे <strong>भारतीय संस्कृती, परंपरा, कौशल्य आणि भक्ती</strong> यांची सजीव अभिव्यक्ती."
            </p>
          </div>
        </div>

        <div className="vastu-modal-footer">
          <button className="vastu-close-btn" onClick={onClose}>बंद करा</button>
        </div>
      </div>
    </div>
  );
};

/* ══════════════════════════════════════════
   FESTIVAL MODAL
══════════════════════════════════════════ */
const FestivalModal = ({ isOpen, onClose }) => {
  const modalRef = useRef(null);



  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      if (modalRef.current) modalRef.current.scrollTop = 0;
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  const handleBackdropClick = (e) => { if (e.target === e.currentTarget) onClose(); };

  useEffect(() => {
    const handleKey = (e) => { if (e.key === 'Escape') onClose(); };
    if (isOpen) window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const festivals = [
    { num: '१)', name: 'दसरा', desc: 'दसऱ्याच्या दिवशी गावातून  सासनकाठ्या व पालखी वर मंदिरात येते व येथे प्रथम सीमा उल्लंघन होते त्यानंतर देवाची आरती होते,त्यानंतर सर्व भाविकांची भेटाभेटी चा कार्यक्रम होतो.' },
    { num: '२)', name: 'कालभैरव अष्टमी', desc: 'कालभैरव अष्टमीला कालभैरवाची विशेष पूजा आणि अभिषेक केला जातो. या दिवशी भक्त रात्री जागरण करतात आणि कालभैरवाची कृपा प्राप्त करतात.' },
    { num: '३)', name: 'माघ पौर्णिमा', desc: 'माघ पौर्णिमेला मंदिरात विशेष स्नान आणि पूजा होते. या दिवशी भक्त मोठ्या संख्येने येऊन देवाला नैवेद्य अर्पण करतात.' },
    { num: '४)', name: 'शिवरात्र', desc: 'महाशिवरात्रीला शिवलिंगावर विशेष अभिषेक आणि रुद्र पूजा केली जाते. भक्त रात्रभर जागरण करून भजन-कीर्तनात मग्न होतात.' },
    { num: '५)', name: 'होळी', desc: 'होळीच्या दिवशी मंदिरात होळी पेटवली जाते आणि रंगांची उधळण होते. संध्याकाळी भजन आणि प्रसाद वाटप केले जाते.' },
    { num: '६)', name: 'पाडवा', desc: 'गुढी पाडव्याला नवीन वर्षाच्या स्वागतार्थ गुढी उभारली जाते. मंदिरात विशेष पूजा आणि महाप्रसादाचे आयोजन केले जाते.' },
    { num: '७)', name: 'रविवार', desc: 'प्रत्येक रविवारी मंदिरात विशेष आरती आणि पूजा होते. भक्त मोठ्या संख्येने येऊन देवाचे दर्शन घेतात आणि महाप्रसाद घेतात.' },
    { num: '८)', name: 'अमावस्या', desc: 'या दिवशी मंदिरात छबिना व आरती आयोजित केली जाते. त्यानंतर महाप्रसादाचे आयोजन केले जाते.' },
    { num: '९)', name: 'सोमवती अमावस्या', desc: 'सोमवती अमावस्येला सासनकाठ्या आणि पालखी मिरवणुकीने  स्थानासाठी कर्हेनदीच्या संगमावर जात असते .' },
  ];

  return (
    <div className="vastu-modal-backdrop" onClick={handleBackdropClick}>
      <div className="vastu-modal" role="dialog" aria-modal="true">
        <div className="vastu-modal-header">
          <div className="vastu-modal-title-wrap">
            <span className="vastu-modal-icon">🎉</span>
            <h2 className="vastu-modal-title">उत्सवाची परंपरा</h2>
          </div>
          <button className="vastu-modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="vastu-modal-body" ref={modalRef}>
          <div className="vastu-modal-divider"><span>✦</span><span>✦</span><span>✦</span></div>
          <h3>मंदिरातील उत्सवांची परंपरा</h3>
          <div className="festival-list-with-desc">
            {festivals.map((f) => (
              <div className="festival-item" key={f.num}>
                <strong>{f.num} {f.name}</strong>
                <p>{f.desc}</p>
              </div>
            ))}
          </div>
          <div className="vastu-modal-divider"><span>✦</span><span>✦</span><span>✦</span></div>
          <p className="vastu-modal-text" style={{ textAlign: 'center', fontStyle: 'italic', marginTop: '20px' }}>
            या सर्व सण-उत्सवांमध्ये मंदिरात विशेष पूजा, भजन, कीर्तन आणि महाप्रसादाचे आयोजन केले जाते.
          </p>
        </div>
        <div className="vastu-modal-footer">
          <button className="vastu-close-btn" onClick={onClose}>बंद करा</button>
        </div>
      </div>
    </div>
  );
};

/* ══════════════════════════════════════════
   HOME
══════════════════════════════════════════ */
const Home = ({ setCurrentPage }) => {
  const { t } = useLanguage();
  const heroRef = useRef(null);
  const donateBtnRef = useRef(null);



  // ── 1. Add this state inside your Home component ──
const [showBooking, setShowBooking] = useState(false);
 
// ── 2. Add this useEffect to close on outside click ──
useEffect(() => {
  if (!showBooking) return;
  const handleOutside = (e) => {
    if (!e.target.closest('.floating-btn-group')) {
      setShowBooking(false);
    }
  };
  document.addEventListener('click', handleOutside);
  return () => document.removeEventListener('click', handleOutside);
}, [showBooking]);


  useEffect(() => {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("visible");
      }
    });
  }, { threshold: 0.12 });

  document.querySelectorAll(
    ".info-card, .fact-card, .event-card, .event-hcard, .facility-card, .reach-card, .ritual-card, .place-card, .testimonial-card"
  ).forEach((el) => observer.observe(el));

  return () => observer.disconnect();
}, []);


 

  const [isVastuModalOpen, setIsVastuModalOpen] = useState(false);
  const [isFestivalModalOpen, setIsFestivalModalOpen] = useState(false);
  const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false);  // ← NEW

  //  const [showBooking, setShowBooking] = useState(false);

  const handleYadnyaClick = () => setCurrentPage('YadnyaBooking');
  const handleMahaprasadClick = () => setCurrentPage('MahaprasadBooking');
  const handleDonationClick = () => setCurrentPage('donation');

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const yOffset = -80;
      const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) entry.target.classList.add('visible');
      });
    }, { threshold: 0.15 });

    document.querySelectorAll(
      '.info-card, .fact-card, .event-card, .facility-card, .reach-card, .ritual-card, .place-card, .testimonial-card'
    ).forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="home-page">

      <VastuModal isOpen={isVastuModalOpen} onClose={() => setIsVastuModalOpen(false)} />
      <FestivalModal isOpen={isFestivalModalOpen} onClose={() => setIsFestivalModalOpen(false)} />
      <TempleHistoryModal isOpen={isHistoryModalOpen} onClose={() => setIsHistoryModalOpen(false)} />

      {/* HERO */}
      <section className="hero-section">
        <picture className="hero-bg-container" ref={heroRef}>
          <source media="(max-width: 768px)" srcSet="/Assets/home/devmobile4.png" />
          <img src="/Assets/home/dev2.jpg" alt={t('templeTitle')} className="hero-bg-img" fetchPriority="high" loading="eager" />
          <HoliColorEffect containerRef={heroRef} />
        </picture>
        <div className="hero-vignette-overlay" />
        <div className="hero-wrapper"><div className="hero-content-center" /></div>
      </section>

      {/* RUNNING BANNER */}
      <section className="running-banner">
        <div className="banner-content">
          <div className="marquee">
            {[0, 1].map((i) => (
              <span className="marquee-text" key={i}>
                <span className="star">★</span>
                {t('pageContent.welcomeTitle')} : {t('home.marqueeMessage')}
                <span className="star">★</span>
              </span>
            ))}
          </div>
        </div>
      </section>

      {/* WELCOME SECTION */}
      <section className="welcome-section">
        <div className="container">
          <div className="welcome-card">
            <div className="welcome-badge">{t('pageContent.welcomeTitle')}</div>
            <h2 className="welcome-title">{t('pageContent.mainTitle')}</h2>
            <div className="welcome-divider"></div>
            <p className="welcome-text">{t('pageContent.welcomeText')}</p>

            {/* ── History Read More Button ── */}
            <button
              className="welcome-read-more-btn"
              onClick={() => setIsHistoryModalOpen(true)}
              aria-label="मंदिराचा इतिहास वाचा"
            >
              <span className="welcome-read-more-icon">📜</span>
              <span>मंदिराचा इतिहास वाचा</span>
              <span className="read-more-arrow">→</span>
            </button>
          </div>
        </div>
      </section>

      {/* TEMPLE SHOWCASE */}
      <section className="temple-showcase" id="showcase">
        <div className="container">
          <h2 className="section-title">{t('home.showcase.title')}</h2>
          <div className="divider"></div>
          <div className="showcase-grid">
            <div className="showcase-image">
              <img src="Assets/home/temple-architecture.jpg" alt={t('home.showcase.overlayText')} className="temple-image" />
              <div className="image-overlay"><p className="overlay-text">{t('home.showcase.overlayText')}</p></div>
            </div>
            <div className="showcase-info">
              <div className="info-card">
                <div className="info-card-header">
                  <div className="info-icon"><Icon name="temple" /></div>
                  <h3>{t('home.showcase.magnificenttitle')}</h3>
                </div>
                <p>{t('home.showcase.magnificentText')}</p>
                <button className="vastu-read-more-btn" onClick={() => setIsVastuModalOpen(true)}>
                  <span>अधिक वाचा</span><span className="read-more-arrow">→</span>
                </button>
              </div>
              <div className="info-card">
                <div className="info-card-header">
                  <div className="info-icon"><Icon name="lamp" /></div>
                  <h3>{t('home.showcase.dailyPoojaTitle')}</h3>
                </div>
                <p>{t('home.showcase.dailyPoojaText')}</p>
                <p>{t('home.showcase.poojaTime')}</p>
                <p>{t('home.showcase.poojaTime2')}</p>
              </div>
              <div className="info-card">
                <div className="info-card-header">
                  <div className="info-icon"><Icon name="prayer" /></div>
                  <h3>{t('home.showcase.spiritualityTitle')}</h3>
                </div>
                <p>{t('home.showcase.spiritualityText')}</p>
              </div>
              <div className="info-card">
                <div className="info-card-header">
                  <div className="info-icon"><Icon name="festival" /></div>
                  <h3>{t('home.showcase.festivalTraditionTitle')}</h3>
                </div>
                <p>{t('home.showcase.festivalTraditionText')}</p>
                <button className="vastu-read-more-btn" onClick={() => setIsFestivalModalOpen(true)} aria-label="उत्सवाची परंपरा अधिक वाचा">
                  <span>अधिक वाचा</span><span className="read-more-arrow">→</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FACTS */}
      <section className="facts-section" id="facts">
        <div className="container">
          <h2 className="section-title">{t('home.facts.title')}</h2>
          <div className="divider"></div>
          <div className="facts-grid">
            <div className="fact-card"><div className="fact-icon"><Icon name="clock" /></div><h3>{t('home.facts.darshanTitle')}</h3><p>{t('home.facts.darshanText')}</p></div>
            <div className="fact-card"><div className="fact-icon"><Icon name="location" /></div><h3>{t('home.facts.locationTitle')}</h3><p>{t('home.facts.locationText')}</p></div>
            <div className="fact-card" onClick={() => scrollToSection('reach')}><div className="fact-icon"><Icon name="car" /></div><h3>{t('home.facts.reachTitle')}</h3><p>{t('home.facts.reachText')}</p></div>
            <div className="fact-card"><div className="fact-icon"><Icon name="phone" /></div><h3>{t('home.facts.contactTitle')}</h3><p>{t('home.facts.contactText')}</p></div>
          </div>
        </div>
      </section>

      {/* EVENTS */}
    {/* EVENTS SECTION */}
      <section className="events-section" id="events">
        <div className="container">
          <h2 className="section-title">{t('home.festivals.title')}</h2>
          <div className="divider"></div>

          {/* ── Grid 1: Major Annual Festivals ── */}
          <div className="events-group-label">🎪 मुख्य वार्षिक उत्सव</div>
          <div className="events-hgrid">

            <div className="event-hcard">
              <div className="event-hicon">
                <img src={yatra} alt="वार्षिक यात्रा" className="chariot-icon" />
              </div>
              <div className="event-hbody">
                <div className="event-hdate">{t('home.festivals.annualYatraDate')}</div>
                <h3>{t('home.festivals.annualYatraTitle')}</h3>
                <p>{t('home.festivals.annualYatraText')}</p>
              </div>
            </div>

            <div className="event-hcard">
              <div className="event-hicon">
                <img src={shravan} alt="श्रावण महिना" className="chariot-icon" />
              </div>
              <div className="event-hbody">
                <div className="event-hdate">{t('home.festivals.shravanMonth')}</div>
                <h3>{t('home.festivals.shravanTitle')}</h3>
                <p>{t('home.festivals.shravanText')}</p>
              </div>
            </div>

            <div className="event-hcard">
              <div className="event-hicon">
                <img src={poornima} alt="पूर्णिमा" className="chariot-icon" />
              </div>
              <div className="event-hbody">
                <div className="event-hdate">{t('home.festivals.everyMonth')}</div>
                <h3>{t('home.festivals.poornimaTitle')}</h3>
                <p>{t('home.festivals.poornimaText')}</p>
              </div>
            </div>

            <div className="event-hcard">
              <div className="event-hicon">
                <img src={kalbhairav} alt="कालभैरव अष्टमी" className="chariot-icon" />
              </div>
              <div className="event-hbody">
                <div className="event-hdate">{t('home.festivals.kalbhairavAshtamiDate')}</div>
                <h3>{t('home.festivals.kalbhairavAshtamiTitle')}</h3>
                <p>{t('home.festivals.kalbhairavAshtamiText')}</p>
              </div>
            </div>

          </div>

          {/* ── Grid 2: Other Festivals & Special Days ── */}
          <div className="events-group-label" style={{ marginTop: '40px' }}>🪔 इतर सण व विशेष दिवस</div>
          <div className="events-hgrid">

            <div className="event-hcard">
              <div className="event-hicon event-hicon--emoji">⚔️</div>
              <div className="event-hbody">
                <div className="event-hdate">आश्विन शुक्ल दशमी</div>
                <h3>दसरा (विजयादशमी)</h3>
                <p>दसऱ्याच्या दिवशी भव्य विजयादशमी पूजा व रावण दहन होते. शक्तीची आराधना केली जाते.</p>
              </div>
            </div>

            <div className="event-hcard">
              <div className="event-hicon event-hicon--emoji">🌙</div>
              <div className="event-hbody">
                <div className="event-hdate">माघ शुक्ल पौर्णिमा</div>
                <h3>माघ पौर्णिमा</h3>
                <p>मंदिरात विशेष स्नान आणि पूजा होते. भक्त देवाला नैवेद्य अर्पण करतात.</p>
              </div>
            </div>

            <div className="event-hcard">
              <div className="event-hicon event-hicon--emoji">🔱</div>
              <div className="event-hbody">
                <div className="event-hdate">फाल्गुन कृष्ण चतुर्दशी</div>
                <h3>महाशिवरात्रि</h3>
                <p>शिवलिंगावर विशेष अभिषेक व रुद्र पूजा होते. रात्रभर भजन-कीर्तन चालते.</p>
              </div>
            </div>

            <div className="event-hcard">
              <div className="event-hicon event-hicon--emoji">🎨</div>
              <div className="event-hbody">
                <div className="event-hdate">फाल्गुन पौर्णिमा</div>
                <h3>होळी</h3>
                <p>मंदिरात होळी पेटवली जाते, रंगांची उधळण होते. संध्याकाळी भजन व प्रसाद वाटप.</p>
              </div>
            </div>

            <div className="event-hcard">
              <div className="event-hicon event-hicon--emoji">🚩</div>
              <div className="event-hbody">
                <div className="event-hdate">चैत्र शुक्ल प्रतिपदा</div>
                <h3>गुडी पाडवा</h3>
                <p>नवीन वर्षाच्या स्वागतार्थ गुढी उभारली जाते. विशेष पूजा व महाप्रसाद होतो.</p>
              </div>
            </div>

            <div className="event-hcard">
              <div className="event-hicon event-hicon--emoji">☀️</div>
              <div className="event-hbody">
                <div className="event-hdate">हर रविवार</div>
                <h3>रविवार विशेष पूजा</h3>
                <p>प्रत्येक रविवारी मंदिरात विशेष आरती व पूजा होते. महाप्रसाद वाटप केले जाते.</p>
              </div>
            </div>

            <div className="event-hcard">
              <div className="event-hicon event-hicon--emoji">🌑</div>
              <div className="event-hbody">
                <div className="event-hdate">हर महिन्याची अमावस्या</div>
                <h3>अमावस्या</h3>
                <p>पितृ तर्पण व विशेष पूजा होते. शांत वातावरणात भजन व आरती चालते.</p>
              </div>
            </div>

            <div className="event-hcard">
              <div className="event-hicon event-hicon--emoji">🪷</div>
              <div className="event-hbody">
                <div className="event-hdate">सोमवारची अमावस्या</div>
                <h3>सोमवती अमावस्या</h3>
                <p>अत्यंत दुर्मिळ व पवित्र दिवस. शिव-विष्णूची विशेष आराधना केली जाते.</p>
              </div>
            </div>

          </div>


{/* ── Special Program - Single Row Horizontal Cards ── */}
<div className="events-group-label" style={{ marginTop: '50px' }}>
  📅 सणाच्या दिवशी विशेष कार्यक्रम
</div>

<div className="special-programs-grid">
  
  {/* Card 1 */}
  <div className="special-program-hcard">
    <div className="sp-icon">🙏</div>
    <div className="sp-content">
      <h3>पूजा व नाथांच्या ओव्या</h3>
      <p className="sp-time">सकाळी ८.३० ते १०.००</p>
    </div>
  </div>

  {/* Card 2 */}
  <div className="special-program-hcard">
    <div className="sp-icon">🎪</div>
    <div className="sp-content">
      <h3>छबिना</h3>
      <p className="sp-time">सकाळी १०.३० ते दुपारी १२.००</p>
    </div>
  </div>

  {/* Card 3 */}
  <div className="special-program-hcard">
    <div className="sp-icon">🍛</div>
    <div className="sp-content">
      <h3>महाप्रसाद</h3>
      <p className="sp-time">दुपारी १२.०० ते सायंकाळी ५.००</p>
    </div>
  </div>

</div>

        </div>
      </section>

      {/* FACILITIES */}
      <section className="facilities-section" id="facilities">
        <div className="container">
          <h2 className="section-title">{t('home.facilities.title')}</h2>
          <div className="divider"></div>
          <div className="facilities-grid">
            {[
              { src: parking, alt: 'Parking', title: t('home.facilities.parkingTitle'), text: t('home.facilities.parkingText') },
              { src: restroom, alt: 'Restroom', title: t('home.facilities.restroomTitle'), text: t('home.facilities.restroomText') },
              { src: water, alt: 'Water', title: t('home.facilities.waterTitle'), text: t('home.facilities.waterText') },
              { src: food, alt: 'Food', title: t('home.facilities.prasadTitle'), text: t('home.facilities.prasadText') },
              { src: accessibility, alt: 'Accessibility', title: t('home.facilities.seniorTitle'), text: t('home.facilities.seniorText') },
              { src: bag, alt: 'Bag', title: t('home.facilities.materialTitle'), text: t('home.facilities.materialText') },
            ].map((f) => (
              <div className="facility-card" key={f.alt}>
                <div className="facility-icon">
                  <img src={f.src} alt={f.alt} className="facility-img" onError={(e) => e.target.src = '/fallback-icon.png'} />
                </div>
                <h3>{f.title}</h3>
                <p>{f.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* REACH */}
      <section className="reach-section" id="reach">
        <div className="container">
          <h2 className="section-title">{t('home.reach.title')}</h2>
          <div className="divider"></div>
          <div className="reach-content">
            <div className="reach-card"><div className="reach-icon"><Icon name="train" /></div><h3>{t('home.reach.railwayTitle')}</h3><p>{t('home.reach.railwayText')}</p><p><strong>{t('home.reach.railwayNote')}</strong></p></div>
            <div className="reach-card"><div className="reach-icon"><Icon name="bus" /></div><h3>{t('home.reach.busTitle')}</h3><p>{t('home.reach.busText')}</p><p><strong>{t('home.reach.busNote')}</strong></p></div>
            <div className="reach-card"><div className="reach-icon"><Icon name="car" /></div><h3>{t('home.reach.carTitle')}</h3><p>{t('home.reach.carText')}</p><p><strong>{t('home.reach.carNote')}</strong></p></div>
            <div className="reach-card"><div className="reach-icon"><Icon name="car" /></div><h3>{t('home.reach.airTitle')}</h3><p>{t('home.reach.airText')}</p><p><strong>{t('home.reach.airNote')}</strong></p></div>
          </div>
        </div>
      </section>

      {/* FLOATING BUTTONS */}
      {/* <div className="floating-btn-group">
        <button className="floating-yadnya-btn" onClick={handleYadnyaClick}>
          <span className="btn-text">{t('yadnya.YadnyaBooking')}</span>
        </button>
        <button className="floating-mahaprasad-btn" onClick={handleMahaprasadClick}>
          <span className="btn-text">{t('mahaprasad.MahaprasadBooking')}</span>
        </button>
        <button ref={donateBtnRef} className="floating-donation-btn" onClick={handleDonationClick}>
          <span className="btn-text">{t('donation.dontionbutton')}</span>
          <span className="btn-icon">₹</span>
        </button>
      </div> */}

{/* // ── 3. Replace your floating-btn-group JSX with this ── */}
 
<div className="floating-btn-group">
 
  {/* Sub-buttons — slide up when expanded */}
  <div className={`booking-sub-buttons ${showBooking ? 'expanded' : ''}`}>
 
    <button
      className="floating-yadnya-btn"
      onClick={() => { setShowBooking(false); handleYadnyaClick(); }}
    >
      <span className="btn-text">{t('yadnya.YadnyaBooking')}</span>
    </button>
 
    <button
      className="floating-mahaprasad-btn"
      onClick={() => { setShowBooking(false); handleMahaprasadClick(); }}
    >
      <span className="btn-text">{t('mahaprasad.MahaprasadBooking')}</span>
    </button>
 
  </div>
 
  {/* Main Booking Toggle */}
  <button
    className={`floating-booking-btn ${showBooking ? 'active' : ''}`}
    onClick={() => setShowBooking((prev) => !prev)}
    aria-expanded={showBooking}
    aria-label="बुकिंग"
  >
    <span className="btn-text"> बुकिंग</span>
    <span className={`booking-arrow ${showBooking ? 'open' : ''}`}>▲</span>
    <span className="btn-icon"></span>
  </button>
 
  {/* Donation — always visible */}
  <button
    ref={donateBtnRef}
    className="floating-donation-btn"
    onClick={handleDonationClick}
  >
    <span className="btn-text">{t('donation.dontionbutton')}</span>
    <span className="btn-icon">₹</span>
  </button>
 
</div>

    </div>
  );
};

export default Home;